import pageData from '../../../common/local/data.json';
import styles from './index.module.less';

function TalentMD() {
  const renderProfile = () => (
    <div className={styles.profile}>
      <div className={styles.title}>{pageData.profile.label}</div>
      <div className={styles.content}>{pageData.profile.content}</div>
    </div>
  );

  const renderStation = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.station.title}</div>
      <div className={styles.content}>{pageData.station.content1}</div>
      <div className={styles.content}>{pageData.station.content2}</div>
      <img src={pageData.station.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.station.content3}</div>
      <img src={pageData.station.imgList[1]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.station.content4}</div>
    </div>
  );

  const renderQintian = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.qintian.title}</div>
      <div className={styles.content}>{pageData.qintian.content1}</div>
      <div className={styles.content}>{pageData.qintian.content2}</div>
      <img src={pageData.qintian.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.qintian.content3}</div>
      <img src={pageData.qintian.imgList[1]} alt="" className={styles.station__img} />
    </div>
  );

  const renderCase = () => (
    <div className={styles.case}>
      {renderStation()}
      {renderQintian()}
    </div>
  );

  return (
    <section className={styles.local}>
      {renderProfile()}
      {renderCase()}
    </section>
  );
}

export default TalentMD;
